import { createContext, useReducer, useEffect } from 'react';

import user from 'services/user';
import { useWallet } from './WalletContext';

const initialState = {
  onboardingModal: false,
  totalRewards: 0,
};

const ACTIONS = {
  SET_ONBOARDING_MODAL: 'SET_ONBOARDING_MODAL',
  SET_TOTAL_REWARDS: 'SET_TOTAL_REWARDS',
};

const AppReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_ONBOARDING_MODAL: {
      return {
        ...state,
        onboardingModal: action.payload,
      };
    }
    case ACTIONS.SET_TOTAL_REWARDS: {
      return {
        ...state,
        totalRewards: action.payload,
      };
    }
  }

  throw Error('Unknown action: ' + action.type);
};

export const AppContext = createContext(null);

export const AppContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);
  const { isAuthenticated } = useWallet();

  const setOnboardingModal = (value) => {
    dispatch({
      type: ACTIONS.SET_ONBOARDING_MODAL,
      payload: value,
    });
  };

  const getTotalRewards = async () => {
    const result = await user.getTotalRewards();

    dispatch({
      type: ACTIONS.SET_TOTAL_REWARDS,
      payload: result.rewards,
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      getTotalRewards();
    }
  }, [isAuthenticated]);

  return (
    <AppContext.Provider
      value={{
        state,
        dispatch,
        setOnboardingModal,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
